import React, { useState } from 'react';

/**
 * MainMenu — Title screen / game select
 *
 * Neon cyberpunk aesthetic. Animated background.
 * Currently only launches Nexus Mayhem.
 */

const styles = {
  container: {
    position: 'absolute',
    top: 0, left: 0, right: 0, bottom: 0,
    background: 'linear-gradient(135deg, #06060c 0%, #0a0a18 50%, #06060c 100%)',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    fontFamily: "'Orbitron', sans-serif",
    zIndex: 500,
    overflow: 'hidden',
  },
  title: {
    fontSize: 'clamp(28px, 6vw, 48px)',
    fontWeight: 900,
    letterSpacing: '6px',
    marginBottom: '4px',
    background: 'linear-gradient(90deg, #00ff41, #00d4ff, #a855f7)',
    WebkitBackgroundClip: 'text',
    WebkitTextFillColor: 'transparent',
    filter: 'drop-shadow(0 0 20px rgba(0, 255, 65, 0.4))',
  },
  subtitle: {
    fontSize: 'clamp(10px, 2vw, 14px)',
    color: '#666',
    letterSpacing: '8px',
    marginBottom: '50px',
    textTransform: 'uppercase',
  },
  playBtn: {
    padding: '18px 60px',
    fontSize: '16px',
    fontWeight: 700,
    fontFamily: "'Orbitron', sans-serif",
    letterSpacing: '4px',
    color: '#00ff41',
    background: 'rgba(0, 255, 65, 0.08)',
    border: '2px solid #00ff41',
    borderRadius: '10px',
    cursor: 'pointer',
    transition: 'all 0.3s ease',
    boxShadow: '0 0 20px rgba(0, 255, 65, 0.15), inset 0 0 20px rgba(0, 255, 65, 0.05)',
    textTransform: 'uppercase',
    marginBottom: '20px',
  },
  version: {
    position: 'absolute',
    bottom: '16px',
    right: '16px',
    fontSize: '10px',
    color: '#333',
    fontFamily: "'JetBrains Mono', monospace",
  },
  brand: {
    position: 'absolute',
    bottom: '16px',
    left: '16px',
    fontSize: '10px',
    color: '#333',
    fontFamily: "'JetBrains Mono', monospace",
  },
  grid: {
    position: 'absolute',
    top: 0, left: 0, right: 0, bottom: 0,
    backgroundImage: `
      linear-gradient(rgba(0,212,255,0.04) 1px, transparent 1px),
      linear-gradient(90deg, rgba(0,212,255,0.04) 1px, transparent 1px)
    `,
    backgroundSize: '60px 60px',
    pointerEvents: 'none',
  },
  glow: {
    position: 'absolute',
    width: '400px',
    height: '400px',
    borderRadius: '50%',
    background: 'radial-gradient(circle, rgba(0,255,65,0.08) 0%, transparent 70%)',
    pointerEvents: 'none',
  },
};

export default function MainMenu({ onStart }) {
  const [hover, setHover] = useState(false);

  return (
    <div style={styles.container}>
      {/* Background elements */}
      <div style={styles.grid} />
      <div style={{ ...styles.glow, top: '-100px', left: '-100px' }} />
      <div style={{ ...styles.glow, bottom: '-100px', right: '-100px', background: 'radial-gradient(circle, rgba(168,85,247,0.06) 0%, transparent 70%)' }} />

      {/* Title */}
      <div style={styles.title}>NEXUS MAYHEM</div>
      <div style={styles.subtitle}>Bullet Heaven</div>

      {/* Play button */}
      <button
        style={{
          ...styles.playBtn,
          ...(hover ? {
            background: 'rgba(0, 255, 65, 0.2)',
            boxShadow: '0 0 40px rgba(0, 255, 65, 0.3), inset 0 0 30px rgba(0, 255, 65, 0.1)',
            transform: 'scale(1.05)',
          } : {}),
        }}
        onClick={() => onStart('nexus-mayhem')}
        onMouseEnter={() => setHover(true)}
        onMouseLeave={() => setHover(false)}
      >
        ENTER THE NEXUS
      </button>

      {/* Footer */}
      <div style={styles.brand}>MISKULIN TECHNOLOGIES</div>
      <div style={styles.version}>v0.1.0</div>
    </div>
  );
}
